export default __webpack_public_path__ + "static/media/442.7312f218.svg";